import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Button, Checkbox, ConfigProvider, message, Modal} from "antd";
import {t} from "i18next";
import {getImagePathSvg, getImagePathWithTheme, getImagePathWithThemeSvg, getSafeInt, isDarkMode} from "@/utils";
import { DndContext, DragEndEvent, PointerSensor, closestCenter, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, arrayMove, horizontalListSortingStrategy, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import './DialogFramePreview.css'
import {getSysConfig, updateSysConfig} from "@model/sysconfig";
import {sortFramePresent} from "@/elementUtility";

const DialogFramePreview = forwardRef((props:{onCloseCallback:any}, ref) => {
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog
    }))
    const [isShowDialog, setIsShowDialog] = useState(false);
    const sensors = useSensors(useSensor(PointerSensor));
    const [arrayFrames,setArrayFrames] = useState([]);
    const mCallback = useRef<any>(null);
    const mszBoardId = useRef<any>(null);

    const onShowDialog = async (szBoardId:any,arrayFrames:any,callback:any)=>{
        setIsShowDialog(true);
        mszBoardId.current = szBoardId;
        mCallback.current = callback;

        let arrayNew:any = [...arrayFrames];
        arrayNew = await sortFramePresent(szBoardId,arrayNew);
        setArrayFrames(arrayNew);
    }


    //拖动排序的
    const handleDragEnd = (event: DragEndEvent) => {
        const { active, over } = event;
        if (!over) {
            return;
        }
        if (active.id !== over.id) {
            const newArrayFrames = [...arrayFrames];

            const oldIndex = newArrayFrames.findIndex((item) => item.id === active.id);
            const newIndex = newArrayFrames.findIndex((item) => item.id === over.id);
            const arrayNewItem = arrayMove(newArrayFrames, oldIndex, newIndex);

            setArrayFrames(arrayNewItem);
            //记忆这个列表...
            const arrayFrameIds:any = [];
            for (let i=0;i<arrayNewItem.length;i++){
                arrayFrameIds.push(arrayNewItem[i].id);
            }
            updateSysConfig(mszBoardId.current,JSON.stringify(arrayFrameIds));
        }
    };

    return <ConfigProvider
        theme={{
            components: {
                Modal: {
                    /* 这里是你的组件 token   DIALOG又配置个别的色？？？？？？ */
                    contentBg:'var(--dialog-dialog-background-color-2c)',
                },
            },
        }}
    >
        <Modal width={520} zIndex={2005} bodyStyle={{height: `${530}px`,}} styles={{
            content: {
                padding:'16px 16px'
            }
        }}
               afterClose={() => {
                   props.onCloseCallback();
               }}
               open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={null}
               onCancel={() => {
                   setIsShowDialog(false)
               }}>
            <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
                <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                    <span className={'dialog-title'}>{t('Reorder frames')}</span>
                    <div style={{flexGrow: '1'}}/>
                </div>
                <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>
                <DndContext sensors={sensors} onDragEnd={handleDragEnd} collisionDetection={closestCenter}>
                    <SortableContext items={arrayFrames} strategy={verticalListSortingStrategy}>
                        <div className={'flex-col'} style={{gap:'16px 0px',height:'420px',overflow:'hidden auto',margin:'0 -16px',padding:'0 16px'}}>
                            {arrayFrames?.map((item:any) => (
                                <DraggableItem tag={item} key={item.id} onUpdate={(tag)=>{

                                }}/>
                            ))}
                        </div>
                    </SortableContext>
                </DndContext>

                <div className={'flex-center mt-32 mb-4'}>
                    <Button
                        // disabled={isStringNullOrEmpty(selectFile)}
                        className='large-w-button button-solid-style font-size-14 font-family-medium'
                        type="primary"
                        onClick={async () => {
                            mCallback.current(arrayFrames);
                            props.onCloseCallback();
                        }}
                        style={{
                            minWidth: '120px',
                            padding:'0 26px',
                            flexShrink:'0',
                            height: '38px'
                        }}
                        htmlType={"submit"}><img className={'img-16'} src={getImagePathSvg('frame_start')}/>{t("Start presentation")}</Button>
                </div>
            </div>
        </Modal>
    </ConfigProvider>
})

export default DialogFramePreview;


const commonStyle: React.CSSProperties = {
    cursor: 'move',
    transition: 'unset', // Prevent element from shaking after drag
    // display:'block',
    height:'26px',
    lineHeight:'26px',
    border:'none'
};

const DraggableItem: React.FC<any> = (props:{tag:any,onUpdate:any}) => {
    const { tag } = props;
    const { listeners, transform, transition, isDragging, setNodeRef } = useSortable({ id: tag.id });
    const style = transform
        ? {
            ...commonStyle,
            transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
            transition: isDragging ? 'unset' : transition, // Improve performance/visual effect when dragging
        }
        : commonStyle;


    return (
        <div className={'flex-row-vertical-center frame-item'} style={{
            ...style,
        }} ref={setNodeRef} {...listeners}>
            <img className={'img-16'} src={getImagePathWithThemeSvg('frame_sort')}/>
            <span className={'ml-8 span-single-line'}>{tag.name}</span>
        </div>
    );
};